import { Building2, Home, Map, Check } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { propertySegments } from '../mockData';

const iconMap = {
  'building-2': Building2,
  'home': Home,
  'map': Map
};

export const PropertySegments = () => {
  return (
    <section id="properties" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Our Property Segments
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Wide range of MVDA & RERA approved properties in premium locations across Vrindavan
          </p>
        </div>

        {/* Property Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {propertySegments.map((segment) => {
            const IconComponent = iconMap[segment.icon];
            return (
              <Card 
                key={segment.id} 
                className="border-2 border-orange-100 hover:border-orange-300 transition-all duration-300 hover:shadow-xl group"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-orange-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl text-gray-900">{segment.title}</CardTitle>
                  <CardDescription className="text-gray-600">{segment.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3 mb-4">
                    {segment.features.map((feature, index) => (
                      <div key={index} className="flex items-start space-x-2">
                        <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div className="flex flex-wrap gap-2 pt-4 border-t border-gray-100">
                    {segment.types.map((type, index) => (
                      <Badge key={index} variant="outline" className="border-orange-300 text-orange-700">
                        {type}
                      </Badge>
                    ))}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};